import React, { useState, useEffect } from 'react';
import AppLoader from 'components/Loader';
import swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { deleteInfoItem, updateInfoItem } from 'redux/thunks/dashboard';
import { resetDeletingInfoItem, resetUpatingInfoItem } from 'redux/actions/dashboard';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import Modal from 'components/ModalWrapper';
import './EditInfoModal.css';

const EditInfoModal = (props) => {
    const { info, onClose, show, siteId, dashboardId } = props;
    const [body, setBody] = useState('');
    const [title, setTitle] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();
    const dashboard = useSelector((state) => state.dashboard);

    useEffect(() => {
        if (info) {
            setBody(info.body);
            setTitle(info.title);
        }
    }, [info]);

    const validate = () => {
        let errors = {};

        if (!title) {
            errors['title'] = '';
        }

        if (!body) {
            errors['body'] = '';
        }

        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleDelete = async () => {
        const result = await swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it.',
        });

        if (result.value) {
            const infoItem = {
                id: info.id,
                siteId: siteId,
                dashboardId: dashboardId,
            };
            dispatch(deleteInfoItem(infoItem));
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!validate()) {
            return;
        }
        const data = {
            id: info.id,
            siteId: siteId,
            dashboardId: dashboardId,
            title: title,
            body: body,
        };
        dispatch(updateInfoItem(data));
    };

    useEffect(() => {
        if (dashboard.updatingInfoItemSuccess || dashboard.deletingInfoItemSuccess) {
            onClose();
            dispatch(resetUpatingInfoItem());
            dispatch(resetDeletingInfoItem());
        }
    }, [dashboard.updatingInfoItemSuccess, dashboard.deletingInfoItemSuccess, onClose, dispatch]);

    return (
        <div>
            <Modal allowClickOutsideToClose height='small' open={show} onCloseClicked={onClose}>
                <Grid container direction='column' className='edit-info-modal'>
                    <Grid container item justifyContent='center' className='edit-info-modal__title'>
                        <Typography variant='h5'>Edit Info</Typography>
                    </Grid>

                    <Grid container direction='column' className='edit-info-modal__body'>
                        {dashboard.updatingInfoItem || dashboard.deletingInfoItem ? (
                            <AppLoader />
                        ) : (
                            <>
                                <TextField
                                    error={'title' in fieldErrors}
                                    helperText={'title' in fieldErrors && 'This field is required'}
                                    {...(title === 'Equipment Number' && { disabled: true })}
                                    label='Title *'
                                    placeholder='Enter your info title'
                                    value={title}
                                    variant='outlined'
                                    className='edit-info-modal__form-field'
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                                <TextField
                                    rows={4}
                                    variant='outlined'
                                    className='edit-info-modal__form-field'
                                    error={'body' in fieldErrors}
                                    helperText={'body' in fieldErrors && 'This field is required'}
                                    label='Body *'
                                    placeholder='Enter your info body'
                                    value={body}
                                    onChange={(e) => setBody(e.target.value)}
                                />
                            </>
                        )}
                    </Grid>

                    <Grid container justifyContent='space-between' className='edit-info-modal__footer'>
                        <div className='edit-info-modal__footer-buttons--left'>
                            <Button
                                color='default'
                                size='large'
                                variant='contained'
                                onClick={props.onClose}
                                className='edit-info-modal__footer-button--close'
                            >
                                Close
                            </Button>
                            {title !== 'Equipment Number' && (
                                <Button
                                    color='secondary'
                                    size='large'
                                    variant='contained'
                                    disabled={dashboard.updatingInfoItem}
                                    onClick={handleDelete}
                                    className='edit-info-modal__footer-button--delete'
                                >
                                    Delete
                                </Button>
                            )}
                        </div>
                        <Button
                            color='primary'
                            size='large'
                            variant='contained'
                            disabled={dashboard.updatingInfoItem}
                            onClick={handleSave}
                            className='edit-info-modal__footer-button--save'
                        >
                            Save Changes
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
};

export default EditInfoModal;
